import { render, staticRenderFns } from "./ResourceViewBuy.vue?vue&type=template&id=78304df7&"
import script from "./ResourceViewBuy.vue?vue&type=script&lang=js&"
export * from "./ResourceViewBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports